// extracted by mini-css-extract-plugin
export default {"subNav":"FlexTemplateHero-module__subNav--iRvU0"};